<script>
    import { createEventDispatcher, onMount } from 'svelte';

    export let lat;
    export let lon;

    let container;
    let map;
    let center;
    let zoom = 18;

    let marker_info = null;
    let marker = null;  

    onMount(() => {
        center = {
            lat: parseFloat(lat),
            lng: parseFloat(lon)
        };

        const options = {
            zoom,
            center,
            mapTypeId: 'hybrid'
        };
        // setup the general Map with the provided options
        map = new google.maps.Map(container, options);

        //console.log('Map created');

        marker = new google.maps.Marker({
                        map,
                        position: center,
                        title: "Course",
                        draggable: false
                    });
    });

</script>

<div class="map" bind:this={container} />

<style>
    .map {
        position: relative;
        left: 0;
        width: 100%;
        height: 700px;
    }
</style>